import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '@hooks/reduxHooks';
import { ROUTES } from '@router/constants';
import { clearClientInfo } from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___pages___/client-info/model/clientInfo.slice';
import { clearShoreUsersState } from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___pages___/shore-users/model/shoreUsers.slice.ts';
import { clearTenantInfoState } from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___pages___/tenant-info/model/tenantInfo.slice.ts';
import { setPublishedSteps } from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/model/configuration.slice.ts';
import { deleteAdminCenterPublishedSteps } from '@store/services/localStorage.service.ts';

const { ADMIN } = ROUTES.SIDEBAR;

const KEEP_SEGMENTS = new Set<string>([
    ADMIN.CONFIGURATION.ROOT,
    ADMIN.SUBSCRIPTIONS,
    ADMIN.MATRICES,
    ADMIN.ROLES,
    ADMIN.ANALYTICS,
    ADMIN.TEMPLATES,
]);

const getAdminSegment = (pathname: string) => {
    const parts = pathname.split('/').filter(Boolean);
    const idx = parts.indexOf(ROUTES.SIDEBAR.ADMIN.ROOT);
    return idx >= 0 ? (parts[idx + 1] ?? '') : '';
};

const isInCreateEditScope = (pathname: string) => KEEP_SEGMENTS.has(getAdminSegment(pathname));

export function useAdminScopeCleaner() {
    const { pathname } = useLocation();
    const dispatch = useAppDispatch();

    useEffect(() => {
        // Clear whenever we're NOT inside one of the keep-scope segments.
        // This includes plain "/admin" (segment === ''), and any non-admin routes.
        if (!isInCreateEditScope(pathname)) {
            dispatch(clearClientInfo());
            dispatch(clearTenantInfoState());
            dispatch(setPublishedSteps(''));
            dispatch(clearShoreUsersState());
            deleteAdminCenterPublishedSteps();
        }
    }, [pathname, dispatch]);
}
